import PDFDocument from 'pdfkit';
import SVGtoPDF from 'svg-to-pdfkit';
import QRCode from 'qrcode';
import streams from 'memory-streams';

const resolution =  2.8346;

export default class Label {
	constructor(labelJSON) {
		this._labelJSON = labelJSON;
		this._labelSize = this._labelJSON.size;
	}

	async getPDF(description) {
		let self = this;

		let labels =  _.isArray(description) ? description : [ description ];

		try {
			let pdfDoc = new PDFDocument({
				size: [self._labelSize.height * resolution, self._labelSize.width * resolution],
				margins: {
					top: 0,
					bottom: 0,
					left: 0,
					right: 0
				}
			});

			let svgToPdfOptions = {
				width: self._labelSize.height * resolution,
				height: self._labelSize.width * resolution,
				assumePt: false,
				preserveAspectRatio: 'none'
			};

			let i = 0;

			do {
				if (i!==0) pdfDoc.addPage();
				let labelSVG = await this.getSVG( labels[i] );
				SVGtoPDF(pdfDoc, labelSVG, 0, 0, svgToPdfOptions);
				i++;
			} while ( i < labels.length );

			const file = new streams.WritableStream();
			pdfDoc.pipe(file);
			pdfDoc.end();

			await new Promise((resolve, reject) => {
				file.on('finish', resolve);
				file.on('error', reject);
			});

			return file.toBuffer();
		} catch (e) {
			console.error(e.message);
		}
	}

	async getSVG(description) {
		let self = this;
		let labelJSON = JSON.parse(JSON.stringify(self._labelJSON));

		let canvas = new fabric.Canvas(null, {
			width: self._labelSize.height * 10,
			height: self._labelSize.width * 10
		});

		let image = _.find(labelJSON.objects, _.matches({type: 'image'}));
		image.src = await QRCode.toDataURL(description, {width: 160});

		let text = _.find(labelJSON.objects, _.matches({type: 'i-text', text: '{{DESCRIPTION}}'}));
		text.text = description;

		await new Promise((r) => canvas.loadFromJSON(JSON.stringify(labelJSON), r));

		canvas.renderAll();
		return canvas.toSVG();
	}
}